<style scoped>
    @import '../assets/css/loggingEvents.css';
</style>
<template>
    <div class="logging-event-row">
        <notification :kind="loggingEventLevel" icon-name="none">
            <div :class="{disabled: isWaitingForDeleteResponse}" class="logging-event-container">
                <div class="logging-event-message">
                    <div class="logging-event-message-body" v-if="shortMessage !== '' && collapsed">
                        <p>
                            <pre>{{shortMessage}}</pre>
                        </p>
                        <span @click="expandMessage()">Show more</span>
                    </div>
                    <div class="logging-event-message-body" v-else>
                        <p> 
                            <pre>{{loggingEvent.Message}}</pre>
                        </p>
                        <span v-if="shortMessage !== ''" @click="collapseMessage()">Show less</span>
                    </div> 
                    <div class="logging-event-message-footer"> 
                        <span><b>Number of occurences:</b> {{loggingEvent.MergedEventsCount}}</span>
                        <span><b>First occurence:</b> {{firstOccurenceTime}}</span>
                        <span><b>Last occurence:</b> {{lastOccurenceTime}}</span>
                    </div>
                </div>
                <div>
                    <img class="close-button" :src="imagePath +'delete-icon.svg'" @click="removeById(loggingEvent.Id)">
                </div>
            </div>
        </notification>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import { NAMESPACE as LOGGING_EVENT_NAMESPACE } from './../store/modules/loggingEvents.js';
    import { NAMESPACE as APP_NAMESPACE } from './../store/modules/app.js';
    import Notification from './Notification';
    import moment from 'moment';

    const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ssZ';

    export default {
        props: ['loggingEvent'],
        data() {
            return {
                collapsed: true,
            }
        },
        components: {
            Notification
        },
        computed: {
            ...mapGetters({
                imagePath: APP_NAMESPACE.getters.IMAGE_PATH,
                rowsWaitingForDelete: LOGGING_EVENT_NAMESPACE.getters.IDS_ARRAY_OF_ROWS_WAITING_FOR_DELETE,
            }),
            loggingEventLevel: function() {
                return (this.loggingEvent.EventLevel == 'WARN') ? 'WARNING': 'ERROR';
            },
            shortMessage: function() {
                if (this.loggingEvent.Message.length > 500) {
                    return this.loggingEvent.Message.substring(0, 500) + '...';
                }
                return '';
            },
            firstOccurenceTime: function() {
                return moment(this.loggingEvent.FirstOccurenceTime).format(DATE_TIME_FORMAT);
            },
            lastOccurenceTime: function() {
                return moment(this.loggingEvent.LastOccurenceTime).format(DATE_TIME_FORMAT);
            },
            isWaitingForDeleteResponse: function() {
                return this.rowsWaitingForDelete.indexOf(this.loggingEvent.Id) >= 0;
            }
        },
        methods: {
            ...mapActions({
                removeById: LOGGING_EVENT_NAMESPACE.actions.DELETE_BY_ID
            }),
            expandMessage: function() {
                this.collapsed = false;
            },
            collapseMessage: function() {
                this.collapsed = true;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/loggingEventRow.vue